// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyAndTerms/style.css
// module id = 3569
// module chunks = 29